import { HomeOfficeRatio } from "../../../features/Dashboard/dashboard.component";
import { useRemoteQuery } from "../useRemote/useRemoteQuery";

export function useRemoteUserHomeOfficeInfo() {
  return useRemoteQuery<HomeOfficeRatio[], unknown>({
    queryKey: "userHomeOfficeInfo",
    url: `/workplace-booking/users-mobile-working-booking-info`
  });
}
